import {
    debrisOnStation,
    howManyAmenitiesDoIHaveInstalled,
    howManyFactionBedsDoIHaveInstalled,
    howManyUpgradedAmenitiesDoIHaveStored,
    howManyUpgradedFactionBedsDoIHaveStored,
    upgradedCoreRoomInStorage
} from '../../../Game/GamePlayerInfo';
import { renovationDestinations } from '../../../TwoD/Common/StationUtilities';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseRenovation extends WeightedChoiceBase {

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.availableSpaces = renovationDestinations(this._gamePlayerData).length > 0;
        this.upgradedCoreRoom = upgradedCoreRoomInStorage(this._gamePlayerData) !== null;
        this.bedCount = howManyFactionBedsDoIHaveInstalled(this._gamePlayerData);
        this.amenityCount = howManyAmenitiesDoIHaveInstalled(this._gamePlayerData);
        this.storedAmenities = howManyUpgradedFactionBedsDoIHaveStored(this._gamePlayerData);
        this.storedBeds = howManyUpgradedAmenitiesDoIHaveStored(this._gamePlayerData);
        this.debris = debrisOnStation(this._gamePlayerData) !== null;
    }

    _novice = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Renovation?', 'Novice');
        let weight = 0;


        let question = 'Upgraded Core Room in Storage?';
        let answer = false;
        let reasoning = `I like to have at least 3 Renovation, I have ${this.total}.`;
        if (this.upgradedCoreRoom){
            answer = true;
            weight += 1;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Do I have 1 Bed or Amenity installed?';
        answer = true;
        reasoning = `I want 1 Bed or Amenity installed, I have ${this.bedCount + this.amenityCount}.`;
        if (this.bedCount + this.amenityCount < 1) {
            answer = false;
            let _question = 'Do I have an Amenity ready?';
            let _answer = false;
            let _reasoning = 'I want an Amenity Installed.'
            if (this.storedAmenities) {
                _answer = true;
                weight += 1;
            }
            this._aiPackage.addProvenance( _question, _answer, _reasoning);

            _question = 'Do I have a Bed ready?';
            _answer = false;
            _reasoning = 'I want a Bed Installed.'
            if (this.storedBeds) {
                _answer = true;
                weight += 1;
            }
            this._aiPackage.addProvenance( _question, _answer, _reasoning);
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        this._weight += weight
    }

    _reasonable = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Renovation?', 'Reasonable');
        let weight = 0;


        let question = 'Upgraded Core Room in Storage?';
        let answer = false;
        let reasoning = `I like to have at least 3 Renovation, I have ${this.total}.`;
        if (this.upgradedCoreRoom){
            answer = true;
            weight += 2;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);


        question = 'Debris on Station?';
        answer = false;
        reasoning = `I like a clean station, and Snohe for Debris.`;
        if (this.debris){
            answer = true;
            weight += 1;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Do I have 1 Bed or Amenity installed?';
        answer = true;
        reasoning = `I want 1 Bed or Amenity installed, I have ${this.bedCount + this.amenityCount}.`;
        if (this.bedCount + this.amenityCount < 1) {
            answer = false;
            let _question = 'Do I have an Amenity ready?';
            let _answer = false;
            let _reasoning = 'I want an Amenity Installed.'
            if (this.storedAmenities) {
                _answer = true;
                weight += 3;
            }
            this._aiPackage.addProvenance( _question, _answer, _reasoning);

            _question = 'Do I have a Bed ready?';
            _answer = false;
            _reasoning = 'I want a Bed Installed.'
            if (this.storedBeds) {
                _answer = true;
                weight += 3;
            }
            this._aiPackage.addProvenance( _question, _answer, _reasoning);
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        this._weight += weight
    }

    _persistent = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Renovation', 'Persistent');
        this._reasonable(true);
        if (this._weight < 1) {
            this._weight = 1
        }
    }
    _unreasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Renovation', 'Unreasonable');
        this._reasonable(true);
        if (this._weight < 2) {
            this._weight = 2
        }

    }

    _obsessed = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Renovation', 'Obsessed');
        this._reasonable(true);
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
